/**
 * Initialisation du monitoring pour DooDates
 * Configure Sentry et le gestionnaire d'erreurs global
 */

import { initSentry } from "./sentry";
import { globalErrorHandler } from "./globalErrorHandler";

/**
 * Initialise tous les systèmes de monitoring
 * @param appName identifiant produit (date-polls, form-polls, …) propagé au tag Sentry `app`
 */
export function initMonitoring(appName?: string) {
  // 1. Initialiser Sentry
  initSentry(appName);

  // 2. Initialiser le gestionnaire d'erreurs global
  globalErrorHandler.initialize();

  // 3. Logger l'initialisation
  console.info("🔍 Monitoring systems initialized");
}

/**
 * Configure le contexte utilisateur pour le monitoring
 */
export function setMonitoringUser(user: {
  id?: string;
  email?: string;
  name?: string;
}) {
  // Envoyer à Sentry
  import("./sentry").then(({ setUserContext }) => {
    setUserContext(user);
  });

  // Logger l'action
  globalErrorHandler.logUserAction("user_context_set", "Monitoring", user);
}

/**
 * Configure le contexte de session pour le monitoring
 */
export function setMonitoringContext(context: {
  sessionId?: string;
  appVersion?: string;
  environment?: string;
}) {
  import("./sentry").then(({ setContext }) => {
    setContext("session", context);
  });

  globalErrorHandler.logUserAction(
    "session_context_set",
    "Monitoring",
    context,
  );
}
